<template>
  <div class="c-config-content">
    <h4 class="c-config-content__title">{{ $t('apiRoute') }}</h4>
    <div v-if="firstLoading">
      <skeleton-loading>
        <row>
          <square-skeleton :boxProperties="{bottom: '10px', height: '30px'}"></square-skeleton>
        </row>
        <row>
          <square-skeleton :boxProperties="{bottom: '10px', height: '200px'}"></square-skeleton>
        </row>
      </skeleton-loading>
    </div>
    <div v-else>
      <div class="c-template-table table-responsive c-role-table">
        <table class="table table-hover">
          <thead>
          <tr>
            <th>{{ $t('apiRouteName') }}</th>
            <th>{{ $t('ext') }}</th>
            <th class="th-80 text-right">
              <span @click="create" class="btn-add"><i class="icon16-plus-circle-gadient"></i></span>
            </th>
          </tr>
          </thead>
          <tbody v-if="items.length">
          <tr v-for="item in items" :key="item._id">
            <td>{{ item.name }}</td>
            <td>{{ item.ext }}</td>
            <td class="text-right">
              <button @click="del(item._id)" :disabled="delLoading" class="mr-1 btn btn-outline-gray btn-sm is-border-1"
                      type="button">
                <b-spinner v-if="delLoading" small></b-spinner>
                <i v-else class="icon12-delete-primary"></i>
              </button>
              <button @click="update(item._id)" :disabled="updateLoading" class="btn btn-outline-gray btn-sm is-border-1"
                      type="button">
                <b-spinner v-if="updateLoading" small></b-spinner>
                <i v-else class="icon12-edit-primary"></i>
              </button>
            </td>
          </tr>
          </tbody>
          <tbody v-else>
          <tr>
            <td colspan="3" class="text-center text-gray-999">{{ $t('noAPIRouteFound') }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <b-modal v-model="showForm" :title="formTitle + $t('apiRouteFormTitle')" @ok="save" no-close-on-backdrop
               no-enforce-focus>
        <div class="row">
          <div class="col">
            <div class="alert alert-warning" v-html="$t('apiRouteNotice')"></div>
            <form-input :label="$t('apiRouteName')" :model="formModel" attribute="name" :errors="formErrors" :placeholder="$t('apiRouteNamePlaceholder')"></form-input>
            <form-input :label="$t('ext')" :model="formModel" attribute="ext" :errors="formErrors" :placeholder="$t('apiRouteExtPlaceholder')"></form-input>
            <form-input :label="$t('apiUrl')" :model="formModel" attribute="apiUrl" :errors="formErrors" :placeholder="$t('apiUrlExtPlaceholder')"></form-input>
            <target-select :label="$t('failedTarget')" :model="formModel" attribute="failedTarget" :errors="formErrors"></target-select>
          </div>
        </div>
        <template v-slot:modal-footer>
          <b-button variant="secondary" class="float-right" @click="showForm = false">{{ $t('cancel') }}
          </b-button>
          <b-button :disabled="saveLoading" variant="primary" class="float-right" @click="save">
            <b-spinner v-if="saveLoading" small></b-spinner>
            {{ $t('save') }}
          </b-button>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import list from '../../../../mixins/List';
import crud from '../../../../mixins/CRUD';
import TargetSelect from "../../../../components/TargetSelect";

export default {
  mixins: [list, crud],
  components: {TargetSelect},
  data: function () {
    return {
      service: '/api-route',
      autoLoad: true,
      defaultFormModel: {
        name: null,
        ext: null,
        apiUrl: null,
        failedTarget: null
      },
    }
  },

}
</script>